import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsExcelService
    ,FvmsApiDtgGeoFenceService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    DtgManageCarSearchComponent
} from "src/app/dtg/manage/car";
import {
    GeofenceConfFormComponent
} from "src/app/dtg/manage/geofence/conf/form/geofence.conf.form.component";

@Component({
    selector: "geofence-route-list"
    ,templateUrl: './geofence.route.list.component.html'
    ,providers: []
})
export class GeofenceRouteListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    pagingInfoConf:PagingInfo = new PagingInfo();
    listGeofence:any[];
    listGeofenceConf:any[];
    listTeam:any[];
    listCarType:any[];
    listRunCnt:any[] = [];
    dtgUnitId:string;
    dtgCarNo:string;
    runDay:string = "2";
    runCnt:any = 1;
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    @Output() geofenceInfo = new EventEmitter();
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    dtgCarType:string = "0";
    useYn:string = "";

    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiDtgGeoFenceService:FvmsApiDtgGeoFenceService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.pagingInfo.pageSize = 15;

        for(let a=1;a<=20;a++){
            this.listRunCnt.push(a);
        }

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                this.pagingInfo.curPage = 1;
                this.reloadListItem();
                this.reloadListGeoFenceConf();
            });
     }

    ngOnInit() {
        this.reloadListItem();
        this.reloadListItemTeam();
        this.reloadListGeoFenceConf();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,searchValue : this.searchValue
            ,dtgUnitId : this.dtgUnitId
            ,dtgCarNo : this.dtgCarNo
            ,runDay : this.runDay
            ,runCnt : this.runCnt
            ,useYn : this.useYn
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConfRoute(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofence = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    reloadListGeoFenceConf(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,searchValue : this.searchValue
            ,useYn : this.useYn
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConf(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofenceConf = apiResponse.resultValue;
                    this.pagingInfoConf = apiResponse.pagingInfo;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSelectGeofence(geofenceInfo:any){
        this.geofenceInfo.emit(geofenceInfo);
    }

    changeRunDay(event){
        this.reloadListItem();
    }

    changeRunCnt(event){
        this.reloadListItem();
    }

    changeRunOrder(item,opt){
        // let runOrder = event.target.value;
        // item.runOrder = runOrder;
        if(opt === "up"){
            item.runOrder--;
            if(item.runOrder <= 0){
                item.runOrder = 1;
            }
        }else{
            item.runOrder++;
        }
        this.fvmsApiDtgGeoFenceService.updateGeoFenceConfRouteOrder(item)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.reloadListItem();
                }
            });
    }

    deleteRunOrder(item){
        this.fvmsApiDtgGeoFenceService.deleteGeoFenceConfRouteOrder(item)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.reloadListItem();
                }
            });
    }

    addRunOrder(item){
        if(!this.dtgUnitId) return;
        item.dtgUnitId = this.dtgUnitId;
        item.runDay = this.runDay;
        item.runCnt = this.runCnt;
        item.createUser = this.currentUserInfo.userId;
        item.updateUser = this.currentUserInfo.userId;
        this.fvmsApiDtgGeoFenceService.upsertGeoFenceConfRouteOrder(item)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.reloadListItem();
                }
            });
    }

    clickOpenModalGeofenceInfo(dtgActionType:DtgActionType,item:any){
        let modalRef = this.modalService.open(
            GeofenceConfFormComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.componentInstance.dtgActionType = dtgActionType;
        modalRef.componentInstance.companyId = item?.companyId || this.companyInfo.companyId;
        modalRef.componentInstance.teamId = item?.dtgTeamId || this.currentUserInfo.teamId;
        modalRef.componentInstance.geoFenceId = item?.geoFenceId;

        modalRef.result.then((resultModal) => {
            
        });
    }

    clickOpenModalGeofenceCarList(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.dtgUnitId = resultModal.carInfo.dtgUnitId;
                this.dtgCarNo = resultModal.carInfo.dtgCarNo;
                this.reloadListItem();
            }
        });
    }

    exportExcel(){

    }
}